$(function () {

    var mapContainer = $('.main_content .map');

    if (mapContainer.length < 1) {
        return;
    }

    mapContainer.googleMaps({
        points: [{
            lat: 53.94922,
            lng: -1.0538,
            marker: '/wp-content/themes/cgit-qc-hub/dist/images/map-marker.png'
        }],
        center: {
            lat: 53.94922,
            lng: -1.0538
        },
        zoom: 13,
        'key': GOOGLE_MAPS_API_KEY,
    });

});